import { useField } from "formik";
import { useState } from "react";
import { useParams } from "react-router-dom";

import { Box, Typography } from "@mui/material";

import { PersonalizedEmailForContactType } from "@interfaces/campaign.type";

import EditPersonalizedEmail from "@pages/CreateCampaign/components/EditPersonalizedEmails/EditPersonalizedEmail";
import EmailList from "@pages/CreateCampaign/components/EditPersonalizedEmails/EmailList";

import { useRemoveEmailQuery } from "@queries/campaign.query";

import EmailLayoutStyles from "./EmailLayoutStyles";

export default function Personalize() {
  const { mutateAsync: removeEmail } = useRemoveEmailQuery();

  const { campaignId } = useParams();

  const [campaignEmailsField] = useField<PersonalizedEmailForContactType[]>("personalizedEmailsForContacts");
  const campaignEmails = campaignEmailsField.value;
  const campaignEmailsExist = campaignEmailsField.value && campaignEmailsField.value.length > 0;

  const [selectedEmailIndex, setSelectedEmailIndex] = useState<number>(0);

  const handleRemoveSelectedEmail = async (emailId: number) => {
    if (!campaignId) return;
    await removeEmail({ campaignId, emailId });
  };

  return (
    <Box sx={{ ...EmailLayoutStyles.root }}>
      {campaignEmailsExist ? (
        <>
          <EmailList
            campaignEmails={campaignEmails}
            removeEmail={handleRemoveSelectedEmail}
            selectedEmailIndex={selectedEmailIndex}
            setSelectedEmailIndex={setSelectedEmailIndex}
          />
          {/*
            MUST USE MAP: individual emails need to map to their own EditPersonalizedEmail to avoid updating the
            incorrect email on every selectedEmailIndex change
          */}
          {campaignEmailsField.value.map((email, index) => {
            if (index == selectedEmailIndex) {
              return <EditPersonalizedEmail emailIndex={index} key={email.id} />;
            }
          })}
        </>
      ) : (
        <Typography component="div" variant="h6">
          No emails to personalize
        </Typography>
      )}
    </Box>
  );
}
